export const DeviceSO = {
    IOS: 'iOS'
  } as const;